import {Dispatch, SetStateAction, useContext} from 'react';

import {useTranslation} from 'react-i18next';

import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {Grid, IconButton, Link, SxProps} from '@mui/material';

import {SnackBarContext} from '../../../../../contexts/SnackBarContext/SnackBarContext';
import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';
import {copyTextToClipBoard} from '../../../../../utils/copyTextToClipboard/copyTextToClipBoard';

interface Props {
  applicantEmail: string;
  applicantLinkedinUrl?: string;
  isEmailIconClicked: boolean;
  setEmailIconClicked: Dispatch<SetStateAction<boolean>>;
}

export default function SocialIconButtons({applicantEmail, applicantLinkedinUrl}: Props) {
  const {t} = useTranslation();
  const {dispatchMessage} = useContext(SnackBarContext);

  const handleEmailIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (applicantEmail) {
      copyTextToClipBoard(applicantEmail);
    }
    dispatchMessage(t('companyApplicants.snackbars.copyEmail'), 'success');
  };

  const handleLinkedinClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!applicantLinkedinUrl) {
      e.preventDefault();
    }
    e.stopPropagation();
  };

  const iconButtonStyles: SxProps = {
    color: greenColors[700],
    backgroundColor: orangeColors[5],
    '&:hover': {
      backgroundColor: orangeColors[3],
    },
  };

  return (
    <>
      <Grid item mr={1}>
        <IconButton
          disabled={!applicantLinkedinUrl}
          LinkComponent={Link}
          href={applicantLinkedinUrl || '#'}
          target='_blank'
          onClick={handleLinkedinClick}
          sx={iconButtonStyles}
          aria-label='linkedin icon'
        >
          <LinkedInIcon />
        </IconButton>
      </Grid>
      <Grid item>
        <IconButton onClick={handleEmailIconClick} disabled={!applicantEmail} sx={iconButtonStyles}>
          <EmailIcon />
        </IconButton>
      </Grid>
    </>
  );
}
